import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Chrome can emit this during layout; CRA's error overlay treats it as fatal.
// Capture-phase filter so the overlay never sees it.
window.addEventListener(
  "error",
  (event) => {
    const message = event?.message || "";
    if (
      message.includes("ResizeObserver loop completed with undelivered notifications") ||
      message.includes("ResizeObserver loop limit exceeded")
    ) {
      event.stopImmediatePropagation();
    }
  },
  true,
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

